import React from "react";
import { Table, Form, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import PrivacyRendererEmail from "./renderers/PrivacyRendererEmail";
import EmailRenderer from "./renderers/EmailRenderer";
import PrivacyRendererPhone from "./renderers/PrivacyRendererPhone";
import PhoneNumberRenderer from "./renderers/PhoneNumberRenderer";

interface DictionaryControlProps
{
    data: any;
    renderers?: any;
    ignores?: string[];
    includes?: string[];
    maps?: any;
    role?: string;
}

interface DictionaryItem
{
    key: string;
    value: any;
    renderer: any;
    position: number;
}

class DefaultRenderer extends React.Component<any>
{
    render(): React.ReactNode 
    {
        return (typeof this.props.value !== "object")
            ?
            <b>{this.props.value}</b>
            :
            "Create a renderer!!";
    }
}

export class DictionaryControl extends React.Component<DictionaryControlProps>
{
    transformedData: DictionaryItem[];

    constructor(props: DictionaryControlProps) 
    {
        super(props);

        this.transformedData = [];

        Object.keys(this.props.data).map((prop: any, i: number) => 
        {
            this.transformedData.push(
                {
                    key: prop,
                    value: this.props.data[prop],
                    renderer: DefaultRenderer,
                    position: i
                });
        });

        if (this.props.renderers) 
        {
            this.props.renderers.map((renderer: any) => 
            {
                const filtered = this.transformedData.filter(data => renderer.keys.includes(data.key));

                filtered.map(itm => 
                {
                    itm.renderer = renderer.renderer;
                });
            });
        }

        if (this.props.data.suppressionFlag)
        {
            if (this.props.role == "academicAdvisor")
            {
                this.transformedData = this.transformedData.filter(itm => itm.key != "email");
                this.transformedData = this.transformedData.filter(itm => itm.key != "phoneNumbers");
            }

            if (this.props.role != "academicAdvisor")
            {
                this.transformedData.map(itm => { itm.key == "email" ? itm.renderer = PrivacyRendererEmail : EmailRenderer });
                this.transformedData.map(itm => { itm.key == "phoneNumbers" ? itm.renderer = PrivacyRendererPhone : PhoneNumberRenderer });
            }
        }
    }

    formatText(camelCase: string): string 
    {
        const splitStr = camelCase.split(/(?=[A-Z])/).join(" ");
        const finalStr = splitStr.charAt(0).toUpperCase() + splitStr.slice(1);

        if (this.props.maps) 
        {
            const mappedValue = this.props.maps[camelCase];

            if (mappedValue)
                return mappedValue;
        }

        return finalStr;
    }

    titleCaseFormat(text: any, key: string)
    {
        if (typeof text === "string")
        {
            if (key.toLowerCase() == "country")
                return text.toUpperCase();

            text = text.replace("(", "( ");
            const splitStr = text.toLowerCase().split(" ");
            for (let i = 0; i < splitStr.length; i++)
            {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            }
            const endText = splitStr.join(" ");
            return endText.replace("( ", "(");
        }
        else
        {
            return text;
        }
    }

    render(): React.ReactNode
    {
        this.transformedData.sort((a, b) => (a.position > b.position) ? 1 : -1);

        return <Form>
            {
                (this.transformedData && this.transformedData.length > 0)
                    ?
                    this.transformedData.map((itm, i) =>
                    {
                        if (this.props.ignores && this.props.ignores.includes(itm.key))
                            return;

                        if ((!this.props.includes || this.props.includes.length == 0) || this.props.includes.includes(itm.key)) 
                        {
                            return <Form.Group as={Row} key={i}>
                                <Form.Label className="grayText" column md="4">
                                    {this.formatText(itm.key)}
                                </Form.Label>
                                <Col md="8">
                                    <Form.Control plaintext as={"div"}>
                                        <itm.renderer value={itm.value ? this.titleCaseFormat(itm.value, itm.key) : "-"} obj={this.props.data} />
                                    </Form.Control>
                                </Col>
                            </Form.Group>;
                        }
                    })
                    :
                    <div></div>
            }
        </Form>;
    }
}